import React, {Component} from 'react';
import {FormFeedback, FormGroup, Label,} from 'reactstrap';
import AutoTextarea from "../../forms/AutoTextarea";

class CommentResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {feedback: 'Comment is required'};
  }

  componentWillMount() {
    // Validate for case of edit
    this.handleInput(this.props.value.comment);
  }

  // ----------------------
  // Methods
  // ----------------------

  handleInput(value, touched) {
    const valueObject = (!!value) ? {comment: value, isValid: true} : {comment: value, isValid: !this.props.requireResponse};
    if (this.props.value.touched || touched) {
      valueObject.touched = true;
    }
    this.props.onValueChange(this.props.name, valueObject);
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillReceiveProps(nextProps) {
    this.setState({feedback: nextProps.value.comment && nextProps.value.comment.length > 0 ? 'Comment must be more than 3 characters' : 'Comment is required'});
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
        <FormGroup>
          <Label style={{whiteSpace: 'pre-wrap'}} for={this.props.name}>{this.props.prompt}</Label>
          <AutoTextarea
            className={(this.props.value.touched && !this.props.value.isValid) ? 'is-invalid' : ''}
            name={this.props.name}
            value={this.props.value.comment}
            onBlur={value => this.handleInput(value, true)}
            onChange={value => this.handleInput(value)}
          />
          <FormFeedback>{this.state.feedback}</FormFeedback>
        </FormGroup>
    );
  }
}

export default CommentResponse;
